<template>

  <div>
    <v-select
      :value="selected"
      @input="change"
      :options="options"
      :placeholder="placeholder">
      <template #option="{ label, object }">
        <div>{{ label }}</div>
        <em v-if="object.type === 'job'">Scorecard da vaga</em>
      </template>
      </v-select>
  </div>

</template>

<script>
export default {
  name: 'SelectAvalibleScoreform',
  props: {
    value: {
      type: [String, Object],
      default: null
    },
    placeholder: {
      type: String,
      default: 'Select a scorecard'
    },
    jobId: {
      type: String,
      default: null
    },
    interviewType: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      'scoreforms': []
    }
  },
  computed: {
    valueId () {
      return this.value && this.value._id ? this.value._id : this.value
    },
    options () {
      return this.scoreforms.map((val) => {
        return {
          label: val.name,
          value: val._id,
          object: val
        }
      })
    },
    selected () {
      return this.options.find((val) => {
        return val.value === this.valueId
      })
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      console.log({
        job_id: this.jobId,
        ...(this.interviewType ? { interview_type: this.interviewType } : {})
      })
      this.$store
      .dispatch('getAvailableJobScoreforms', {
        job_id: this.jobId,
        ...(this.interviewType ? { interview_type: this.interviewType } : {})
      })
      .then((result) => {
        this.scoreforms = result
      })
    },
    change (val) {
      const value = val ? val.value : null
      const valueObject = val ? val.object : null

      if (value !== this.valueId) {
        this.$emit('input', value)
        this.$emit('inputObject', valueObject)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Fields/SelectAvalibleScoreform.vue